import { render, staticRenderFns } from "./TitleLandingpage.vue?vue&type=template&id=7c840d9c"
import script from "./TitleLandingpage.vue?vue&type=script&lang=js"
export * from "./TitleLandingpage.vue?vue&type=script&lang=js"
import style0 from "./TitleLandingpage.vue?vue&type=style&index=0&id=7c840d9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports